import { fromJS } from 'immutable'
import { LOGOUT } from '../authentication/constants'
import * as actionTypes from './constants'

const initialState = fromJS({})

function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.CLEAR_GROUPS:
      return state
        .set('gettingGroups', false)
        .set('updatingGroupsBatch', false)
        .set('creatingGroup', false)
        .delete('getGroupsError')
        .delete('groups')
    case actionTypes.GET_GROUPS:
      return state.set('gettingGroups', true).delete('getGroupsError')
    case actionTypes.GET_GROUPS_DONE:
      return state
        .set('gettingGroups', false)
        .setIn(['groups', action.page || 0], action.groups)
    case actionTypes.GET_GROUPS_ERROR:
      return state
        .set('gettingGroups', false)
        .set('getGroupsError', action.error)

    case actionTypes.UPDATE_GROUPS_BATCH:
      return state
        .set('updatingGroupsBatch', true)
        .delete('updateGroupsBatchError')
    case actionTypes.UPDATE_GROUPS_BATCH_DONE:
      return state.set('updatingGroupsBatch', false)
    case actionTypes.UPDATE_GROUPS_BATCH_ERROR:
      return state
        .set('updatingGroupsBatch', false)
        .set('updateGroupsBatchError', action.error)

    case actionTypes.CREATE_GROUP:
      return state
        .set('creatingGroup', true)
        .delete('createGroupError')
        .delete('createdGroup')
    case actionTypes.CREATE_GROUP_DONE:
      return state.set('creatingGroup', false).set('createdGroup', action.group)
    case actionTypes.CREATE_GROUP_ERROR:
      return state
        .set('creatingGroup', false)
        .set('createGroupError', action.error)

    case LOGOUT:
      return initialState
    default:
      return state
  }
}

export default reducer
